import { PropsWithChildren } from "react";
import { createPortal } from "react-dom";
import { Show } from "shared/components";
import { Loader } from "shared/components/Loader";
import { cx } from "shared/utils";
import { useCombinedIncome } from "../context";
import { CombinedIncomeMode } from "../types";

export const CombinedIncomeLayout = ({
  title,
  subtitle,
  footer,
  children,
  isLoading,
  contentClassName
}: PropsWithChildren<{
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  footer?: React.ReactNode;
  isLoading?: boolean;
  contentClassName?: string;
}>) => {
  const { mode, footerSlot } = useCombinedIncome();

  if (mode === CombinedIncomeMode.AddNewIncomeSource)
    return (
      <div className="p-6">
        <p className="font-bold mb-4 -mt-2">{title}</p>
        {children}

        {footer && footerSlot ? createPortal(footer, footerSlot) : null}
      </div>
    );

  if (isLoading)
    return (
      <div className="h-[calc(80vh-72px)] w-full flex items-center justify-center">
        <Loader />
      </div>
    );

  return (
    <div className="h-[calc(80vh-72px)] w-full flex flex-col">
      <div
        className={cx(
          "h-full w-full flex-1 py-6 px-12 overflow-y-auto",
          contentClassName
        )}
      >
        <div className="mb-6 space-y-1">
          <h1 className="font-bold text-xl text-content-1000">{title}</h1>
          <Show if={subtitle}>
            <p className="text-sm text-content-400">{subtitle}</p>
          </Show>
        </div>

        {children}
      </div>
      <Show if={footer}>
        <div className="border-t border-alpha-100 bg-white">
          <div className="w-full flex justify-end px-6 py-4 gap-2">
            {footer}
          </div>
        </div>
      </Show>
    </div>
  );
};
